var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvolvement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 23.768,
    viewBox: "0 0 27 23.768",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2345",
    "data-name": "Group 2345",
    transform: "translate(-322.75 -342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "round-engineering",
    d: "M10.6,18.156c-3.039,0-9.1,1.525-9.1,4.552v1.138a1.141,1.141,0,0,0,1.138,1.138H18.57a1.141,1.141,0,0,0,1.138-1.138V22.708C19.708,19.681,13.643,18.156,10.6,18.156ZM5.756,11.328h9.707a.559.559,0,0,0,.558-.558v-.023a.558.558,0,0,0-.558-.558h-.307A4.548,4.548,0,0,0,12.88,6.264V7.345a.569.569,0,1,1-1.138,0V5.8A4.655,4.655,0,0,0,10.6,5.638,4.655,4.655,0,0,0,9.466,5.8V7.345a.569.569,0,0,1-1.138,0V6.264A4.548,4.548,0,0,0,6.052,10.19h-.3a.558.558,0,0,0-.558.558v.034A.556.556,0,0,0,5.756,11.328ZM10.6,15.88A4.552,4.552,0,0,0,15,12.466H6.211A4.552,4.552,0,0,0,10.6,15.88Zm14.772-7.7,1.058-.945-.854-1.479L24.226,6.2a2.256,2.256,0,0,0-.535-.307L23.407,4.5H21.7l-.285,1.388a2.585,2.585,0,0,0-.546.307l-1.343-.444-.854,1.479,1.058.945a2.573,2.573,0,0,0,0,.592l-1.058.967.854,1.479,1.366-.432a2.616,2.616,0,0,0,.489.285l.319,1.4h1.707l.307-1.388a2.709,2.709,0,0,0,.5-.285l1.354.432.854-1.479-1.058-.967A2.7,2.7,0,0,0,25.376,8.176Zm-2.822,1.73a1.423,1.423,0,1,1,1.423-1.423,1.423,1.423,0,0,1-1.423,1.423Zm-.114,3.46-.967.319a1.536,1.536,0,0,0-.376-.216l-.2-1H19.674l-.2.99a2.12,2.12,0,0,0-.387.216l-.956-.319-.615,1.058.751.671a2.6,2.6,0,0,0,0,.421l-.751.694.615,1.058.979-.307a2.189,2.189,0,0,0,.353.2l.2,1H20.88l.216-.99a2.294,2.294,0,0,0,.364-.2l.967.307.615-1.058-.751-.694a2.6,2.6,0,0,0,0-.421l.751-.671-.6-1.058Zm-2.162,2.959a1.013,1.013,0,1,1,1.013-1.013A1.015,1.015,0,0,1,20.277,16.324Z",
    transform: "translate(321.25 337.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M6.16,17.836.265,11.942a.907.907,0,0,1,0-1.283L1.548,9.377a.907.907,0,0,1,1.283,0L6.8,13.347l8.505-8.505a.907.907,0,0,1,1.283,0l1.283,1.283a.907.907,0,0,1,0,1.283L7.443,17.836a.907.907,0,0,1-1.283,0Z",
    transform: "translate(331.613 347.666)",
    fill: "#00c742"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvolvement);
export default __webpack_public_path__ + "static/media/involvement.68cfb29d56084b8311a1d54fe25ba353.svg";
export { ForwardRef as ReactComponent };